import script from "./Register.vue?vue&type=script&setup=true&lang=js"
export * from "./Register.vue?vue&type=script&setup=true&lang=js"

import "./Register.vue?vue&type=style&index=0&id=3925e321&scoped=true&lang=css"
script.__scopeId = "data-v-3925e321"

export default script